import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, inject } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { EsportsBannerViewModel } from '@frontend/sports/types/components/banners/models';
import { LocalStoreService } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BannerTrackingService } from './banner-tracking.service';

@Component({
    selector: 'ms-banner-esport',
    templateUrl: './banner-esport.component.html',
    styleUrl: './banner-esport.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgOptimizedImage, IconCustomComponent],
})
export class BannerEsportComponent implements OnChanges, OnInit {
    @Input() model: EsportsBannerViewModel;
    @Output() bannerDataLoaded = new EventEmitter<boolean>();
    @HostBinding('class') className = 'banner-esport';

    @HostBinding('class.hidden') hidden = true;
    private readonly closeBannerKey = 'is-esport-banner-closed';
    private localStorage = inject(LocalStoreService);
    private trackingService = inject(BannerTrackingService);

    ngOnInit(): void {
        if (this.model) {
            this.trackingService.trackEsportBanner(false);
        }
    }

    ngOnChanges(changes: ISimpleChanges<BannerEsportComponent>): void {
        if (changes.model?.currentValue) {
            this.hidden = !!this.localStorage.get<boolean>(this.closeBannerKey);
            this.bannerDataLoaded.emit(true);
        }
    }

    onClose(): void {
        this.hidden = true;
        this.localStorage.set<boolean>(this.closeBannerKey, true);
        this.trackingService.trackEsportBanner(true);
    }
}
